import { DataExportOptions } from './data-export-options';

/**
 * Data export options for CSV format.
 */
export class CsvDataExportOptions extends DataExportOptions {
	includeHeaders!: boolean;
}
